import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    cursor: 'default'
  }
}))

export default useStyles
